import React from 'react';
import { Link } from 'react-router-dom';
import _keyBy from 'lodash/keyBy';
import { FaMapMarkedAlt, FaTimes, FaPlus, FaTrash } from 'react-icons/fa';
import {
  Button,
  Col,
  Container,
  Row,
  FormControl,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import {
  PROSPECTO_STATUS,
  EMPREENDIMENTO_LANCAMENTO,
  PROSPECTO_STATUS_ENUM,
} from '~/constant';
import { format } from '~/Utils/Helpers';
import AuthStorage, { default as auth } from '~/Utils/AuthStorage';

const PROSPECTO_STATUS_BY_ID = _keyBy(PROSPECTO_STATUS, 'value');

export default function ItemEmpreendimento({
  onClickEmpreendimento,
  exibeAcoes,
  exibeContador,
  descricao,
  isSelecionado,
  empreendimento,
  onClickEditarEmpreendimento,
  editandoEmpreendimento,
  onClickCancelar,
  linkReservar,
  exibeBotoes = true,
}) {
  const vinculoValido =
    empreendimento.codigo_status !== PROSPECTO_STATUS_ENUM.descartado;
  const codigoUsuario = auth.getUser().usuario;
  const podeDescartar =
    vinculoValido &&
    (empreendimento.codigo_corretor === codigoUsuario ||
      empreendimento.codigo_gerente === codigoUsuario ||
      auth.isADM() ||
      auth.temCaracteristica(570)) &&
    empreendimento.codigo_status !== PROSPECTO_STATUS_ENUM.venda_realizada;

  let selectoStyle = `.empreendimento-${
    empreendimento.codigo_familia
  }::before{ border-left-color: ${
    empreendimento.imobiliaria ? empreendimento.imobiliaria.cor : 'transparent'
  } }`;

  const styleProspecto = (
    <style dangerouslySetInnerHTML={{ __html: selectoStyle }}></style>
  );
  return (
    <div
      className={`arrow-bottom-left d-flex w-100 justify-content-between align-items-stretch align-items-lg-center ${isSelecionado &&
        'text-primary'} ${exibeAcoes &&
        exibeContador &&
        'Empreedimento__etiqueta-contador'} Empreendimento__item empreendimento-${
        empreendimento.codigo_familia
      }`}
    >
      {styleProspecto}
      <div
        className="d-flex justify-content-between flex-column Empreendimento__detalhes-wrapper "
        onClick={onClickEmpreendimento}
      >
        <div className="Empreendimento__detalhes">
          <p className=" align-middle line-height-1 m-0">{descricao}</p>
          <ul className="list-unstyled flex-wrap d-flex mb-0 mt-1 Empreendimento__lista-detalhes">
            {!editandoEmpreendimento &&
              PROSPECTO_STATUS_BY_ID[empreendimento.codigo_status] && (
                <li className="mr-2 mb-1">
                  <small className="d-block text-muted">Status</small>
                  <strong className="d-block font-weight-normal">
                    {PROSPECTO_STATUS_BY_ID[empreendimento.codigo_status].label}
                  </strong>
                </li>
              )}
            <li className="mr-2 mb-1">
              <small className="d-block text-muted">Data de vínculo</small>
              <strong className="d-block font-weight-normal">
                {format.date(empreendimento.data_vinculo)}
              </strong>
            </li>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-corretor">
                  {empreendimento.corretor ? empreendimento.corretor.nome : ''}
                </Tooltip>
              }
            >
              <li className="mr-2 mb-1" style={{ maxWidth: 90 }}>
                <small className="d-block text-muted">Corretor</small>
                <strong
                  className="d-block font-weight-normal"
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {empreendimento.corretor ? empreendimento.corretor.nome : ''}
                </strong>
              </li>
            </OverlayTrigger>
            <li className="mr-2 mb-1">
              <small className="d-block text-muted">Imobiliária</small>
              <strong className="d-block font-weight-normal">
                <strong
                  className="bullet"
                  style={{
                    backgroundColor: empreendimento.imobiliaria
                      ? empreendimento.imobiliaria.cor
                      : 'transparent',
                  }}
                ></strong>{' '}
                {empreendimento.imobiliaria
                  ? empreendimento.imobiliaria.nome
                  : ''}
              </strong>
            </li>
          </ul>
        </div>
      </div>

      <div className="Empreendimento__item__actions d-flex flex-row align-items-stretch align-items-lg-center">
        {exibeAcoes && exibeBotoes && (
          <>
            <div className="d-flex flex-column flex-lg-row align-items-lg-center Empreendimento__action-reservar">
              {empreendimento &&
                empreendimento.codigo_familia !== EMPREENDIMENTO_LANCAMENTO && (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={linkReservar}
                    className="d-block btn btn-outline-success"
                  >
                    <FaMapMarkedAlt />
                    <span className="ml-xl-1 d-none d-lg-block d-xl-inline">
                      Reservar Lote
                    </span>
                  </a>
                )}
            </div>
          </>
        )}

        {podeDescartar && (
          <button
            className="d-block btn btn-outline-secondary"
            type="button"
            onClick={onClickEditarEmpreendimento}
          >
            <FaTrash />
            <span className="ml-xl-1 d-none d-lg-block d-xl-inline">
              Descartar
            </span>
          </button>
        )}
        {((exibeAcoes && exibeBotoes) ||
          AuthStorage.temCaracteristica(570)) && (
          <div className="Empreendimento__action-adicionar">
            <Link
              className="d-block h-100 btn btn-outline-primary Empreendimtno__btn-adicionar"
              to={{ search: '?vincular-empreendimento=true' }}
            >
              <FaPlus />
              <span className="ml-xl-1 d-none d-lg-block d-xl-inline">
                Adicionar
              </span>
            </Link>
          </div>
        )}
      </div>

      {editandoEmpreendimento === empreendimento.codigo_familia && (
        <div
          className="Empreendimento__item__actions Empreendimento__item__action--cancelar  btn btn-link cursor-pointer btn-sm"
          onClick={onClickCancelar}
        >
          <FaTimes />
          <span className="ml-1">Cancelar</span>
        </div>
      )}
    </div>
  );
}
